import React, { useEffect, useState } from "react";
import { Modal, Row, Col, Label,  Form, ModalBody } from "reactstrap";
import {
  getCalificacionContactoforCampaign,
  getCampaignFullList,
  getContactsFullList,
  getDescripcionCalificacion,
  postContactsCreate,
  postGestionContactsCreate,
  postLeadsStatusChange,
} from "../../../helpers/backend";
import Select from "react-select";
import SweetAlert from "react-bootstrap-sweetalert";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import ContactsSelect from "../../../components/ContactsSelect";
import "../css/ManagementManual.css";
import { useSelector } from "react-redux";

const ManagementManual = ({ isOpen, onClose, isLead, contactId, leadId }) => {
  const [alert, setAlert] = useState(false);
  const [close, setClose] = useState(false);
  const [status, setStatus] = useState(false);
  const [disableContact, setDisableContact] = useState(false);
  const [message, setMessage] = useState("");
  const [contacts, setContacts] = useState([]);
  const [calificacionList, setCalificacionList] = useState(null);
  const [descripcionList, setDescripcionList] = useState([]);
  const [showNewContactFields, setShowNewContactFields] = useState(false);
  const [campaignData, setCampaignData] = useState({});
  const [gestionId, setGestionId] = useState(null);
  const [newContactCreated, setNewContactCreated] = useState(null);
  const [validationErrors, setValidationErrors] = useState({
    phone: false,
    email: false,
    calificacion: false,
    descripcion: false,
  });
  const [validationErrors2, setValidationErrors2] = useState({
    calificacion: false,
    descripcion: false,
  });
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  const ciudadOptions = [
    { label: "Bogotá", value: "BOGOTA" },
    { label: "Bucaramanga", value: "BUCARAMANGA" },
  ];

  const [formData, setFormData] = useState({
    calificacion: "",
    descripcion: "",
    observaciones: "",
    contacto: "",
    nombre: "",
    apellido: "",
    phone: "",
    email: "",
    sala_ventas: " ",
    placa: " ",
    campaign: [],
    fecha_proximo_contacto: null,
    hora_proximo_contacto: null,
  });

  const {
    contacto,
    nombre,
    apellido,
    phone,
    email,
    calificacion,
    descripcion,
    observaciones,
    sala_ventas,
    placa,
    campaign,
    fecha_proximo_contacto,
    hora_proximo_contacto,
  } = formData;

  const validateForm = () => {
    let errors = {
      phone: !formData.phone,
      email: !emailRegex.test(formData.email),
    };
    setValidationErrors(errors);
    return !Object.values(errors).some(Boolean);
  };

  const validateForm2 = () => {
    let errors = {
      calificacion: !formData.calificacion,
      descripcion: !formData.descripcion,
    };
    setValidationErrors2(errors);
    return !Object.values(errors).some(Boolean);
  };

  const getContactsData = async () => {
    const response = await getContactsFullList();
    setContacts(response.data);
  };

  const getCalificacionData = async (id) => {
    const response = await getCalificacionContactoforCampaign(id);
    setCalificacionList(response.data);
  };

  const getDescripcionData = async (id) => {
    const response = await getDescripcionCalificacion(id);
    setDescripcionList(response.data);
  };

  const getCampaignData = async () => {
    const response = await getCampaignFullList();
    setCampaignData(response.data);
  };

  useEffect(() => {
    getContactsData();
    getCampaignData();
  }, []);

  useEffect(() => {
    if (contactId) {
      setFormData({ ...formData, contacto: contactId });
      setDisableContact(true);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [contactId]);

  useEffect(() => {
    if (formData.calificacion) {
      getDescripcionData(formData.calificacion);
    }
  }, [formData.calificacion]);

  useEffect(() => {
    if (formData.campaign) {
      getCalificacionData(formData.campaign);
    }
  }, [formData.campaign]);

  const toggleNewContactFields = () => {
    if (newContactCreated) return;
    setShowNewContactFields(!showNewContactFields);
  };

  const handleSaveNewContact = async (e) => {
    e.preventDefault();
    if (validateForm()) {
      const response = await postContactsCreate({
        first_name: nombre,
        last_name: apellido,
        email: email,
        phone: phone,
      });
      setStatus(response.status);
      setAlert(true);
      setMessage(response.data.message);
      if (response.status === 201) {
        const newContact = response.data;
        setContacts([...contacts, newContact]);
        setFormData({ ...formData, contacto: newContact.id });
        setNewContactCreated(newContact);
        setShowNewContactFields(false);
      }
    }
  };

  const onSubmit = async () => {
    if (!validateForm2()) {
      setAlert(true);
      setMessage("Por favor, complete todos los campos obligatorios.");
      return;
    }
    let dataToSend = {
      contacto: contacto,
      calificacion: calificacion,
      descripcion: descripcion,
      observaciones: observaciones,
      estado: "FINALIZADO",
      sala_ventas: sala_ventas,
      placa: placa,
      campaign: campaign,
      is_leads: isLead,
    };

    if (fecha_proximo_contacto !== null) {
      dataToSend.fecha_proximo_contacto = fecha_proximo_contacto;
    }
    if (hora_proximo_contacto !== null) {
      dataToSend.hora_proximo_contacto = hora_proximo_contacto;
    }

    const response = await postGestionContactsCreate(dataToSend);
    setStatus(response.status);
    setClose(true);
    setMessage(response.data.message);
    setGestionId(response.data.id);
  };

  const FinalizarGestion = async () => {
    const response = await postLeadsStatusChange(leadId, {
      accion: "FINALIZAR",
      gestion: gestionId,
    });
    console.log(response);
  };

  const theme = useSelector((state) => state.theme.theme) || "light";

  return (
    <>
      {(status === 201 || status === 200) && alert ? (
        <SweetAlert
          title="Hecho!"
          success
          timeout={2000}
          showConfirm={false}
          onConfirm={() => {
            setAlert(false);
            setShowNewContactFields(false);
          }}
        >
          {message}
        </SweetAlert>
      ) : null}
      {(status === 201 || status === 200) && close ? (
        <SweetAlert
          title="Hecho!"
          success
          timeout={2000}
          showConfirm={false}
          onConfirm={() => {
            FinalizarGestion();
            setClose(false);
            onClose();
          }}
        >
          {message}
        </SweetAlert>
      ) : null}
      {status !== 201 && status !== 200 && alert ? (
        <SweetAlert
          title="Error"
          error
          timeout={2000}
          showConfirm={false}
          onConfirm={() => {
            setAlert(false);
          }}
        >
          {message}
        </SweetAlert>
      ) : null}

      <Modal
        isOpen={isOpen}
        toggle={onClose}
        size="lg"
        className="management-modal"
        centered
      >
        <ModalBody style={{ padding: "2rem 2rem 0 2rem" }}>
          <div className="mx-2 text-dark">
            <h5 className="font-size-19 text-dark">
              <i className="fas fa-tasks me-2 "></i>
              <b>Gestión Manual</b>
            </h5>
          </div>

          <div className="form-section">
            <div
              className={`form-card ${
                !showNewContactFields ? "animated-card" : ""
              }`}
            > 
              <Row>
                <Col lg={12} className="contact-section">
                  {newContactCreated ? (
                    <div className="contact-badge">
                      <i className="fas fa-user-check me-2"></i>
                      {`${newContactCreated.first_name} ${newContactCreated.last_name}`}
                      <button
                        className="btn btn-sm btn-outline-secondary ms-2"
                        onClick={() => setNewContactCreated(null)}
                      >
                        <i className="fas fa-edit"></i>
                      </button>
                    </div>
                  ) : (
                    <>
                      <Label
                        style={{ color: theme === "dark" && "#c3cbe4" }}
                        for="contacto"
                        className="form-label"
                      >
                        <i className="fas fa-user me-2"></i>Contacto
                      </Label>
                      <div className="contact-select-container">
                        <div className="select-wrapper">
                          <ContactsSelect
                            isMulti={false}
                            value={formData.contacto}
                            disableConditions={
                              showNewContactFields || disableContact
                            }
                            onContactSelect={(selectedId) =>
                              setFormData({ ...formData, contacto: selectedId })
                            }
                            color={true}
                          />
                        </div>
                        {!disableContact && (
                          <button
                            className="add-contact-btn pulse-effect"
                            onClick={toggleNewContactFields}
                            disabled={showNewContactFields}
                          >
                            <i className="fas fa-plus"></i>
                          </button>
                        )}
                      </div>
                    </>
                  )}
                </Col>
              </Row>

              {showNewContactFields && (
                <Form onSubmit={handleSaveNewContact} className="mt-3">
                  <Row>
                    <Col md={6}>
                      <Label
                        style={{ color: theme === "dark" && "#c3cbe4" }}
                        for="nombre"
                        className="form-label"
                      >
                        Nombre
                      </Label>
                      <input
                        type="text"
                        id="nombre"
                        name="nombre"
                        required
                        className="input_create_contact input_background"
                        onChange={(e) =>
                          setFormData({ ...formData, nombre: e.target.value })
                        }
                      />
                    </Col>
                    <Col md={6}>
                      <Label
                        style={{ color: theme === "dark" && "#c3cbe4" }}
                        for="apellido"
                        className="form-label"
                      >
                        Apellido
                      </Label>
                      <input
                        type="text"
                        id="apellido"
                        name="apellido"
                        className="input_create_contact input_background"
                        required
                        onChange={(e) =>
                          setFormData({ ...formData, apellido: e.target.value })
                        }
                      />
                    </Col>
                  </Row>

                  <Row>
                    <Col md={6}>
                      <Label
                        style={{ color: theme === "dark" && "#c3cbe4" }}
                        for="email"
                        className="form-label"
                      >
                        Email
                      </Label>
                      <input
                        id="email"
                        name="email"
                        type="email"
                        required
                        className="input_create_contact input_background"
                        onChange={(e) => {
                          setFormData({ ...formData, email: e.target.value });
                          setValidationErrors({
                            ...validationErrors,
                            email: false,
                          });
                        }}
                        isInvalid={validationErrors.email}
                      />
                      {validationErrors.email && (
                        <div className="text-danger small">
                          El correo electrónico es obligatorio y debe tener un
                          formato válido
                        </div>
                      )}
                    </Col>
                    <Col md={6}>
                      <Label
                        style={{ color: theme === "dark" && "#c3cbe4" }}
                        for="phone"
                        className="form-label"
                      >
                        Teléfono
                      </Label>
                      <PhoneInput
                        inputProps={{
                          name: "phone",
                          required: true,
                          className: validationErrors.phone ? "is-invalid" : "",
                        }}
                        id="phone"
                        name="phone"
                        country={"co"}
                        value={phone}
                        onChange={(item) => {
                          setFormData({ ...formData, phone: item });
                          setValidationErrors({ phone: false });
                        }}
                      />
                      {validationErrors.phone && (
                        <div className="text-danger small">
                          El teléfono es obligatorio
                        </div>
                      )}
                    </Col>
                  </Row>

                  <Row className="mt-3">
                    <Col className="d-flex justify-content-end">
                      <button
                        type="button"
                        className="button_cancel me-2"
                        onClick={toggleNewContactFields}
                      >
                        Cancelar
                      </button>
                      <button type="submit" className="button_create">
                        Guardar Contacto
                      </button>
                    </Col>
                  </Row>
                </Form>
              )}
            </div>

            {!showNewContactFields && (
              <div className="form-card animated-card">
                <Row>
                  <Col lg={12} className="mb-4">
                    <Label
                      style={{ color: theme === "dark" && "#c3cbe4" }}
                      for="campaign"
                      className="form-label"
                    >
                      <i className="fas fa-bullhorn me-2"></i>Campaña
                    </Label>
                    <Select
                      options={
                        Array.isArray(campaignData)
                          ? campaignData.map((item) => ({
                              label: item.name,
                              value: item.id,
                            }))
                          : []
                      }
                      onChange={(selectedOptions) => {
                        const selectedContactData = selectedOptions.map(
                          (option) => option.value
                        );
                        setFormData({
                          ...formData,
                          campaign: selectedContactData,
                        });
                      }}
                      placeholder={"Seleccione"}
                      isMulti={true}
                      styles={{
                        control: (base) => ({
                          ...base,
                          backgroundColor:
                            theme === "dark" ? "#3b3b3b" : "#fff",
                          color: theme === "dark" ? "#c3cbe4" : "#000",
                          borderColor: theme === "dark" ? "#4f4f4f" : "#d2d2d2",
                          cursor: "pointer",
                          fontSize: "0.9rem",
                        }),
                        menu: (base) => ({
                          ...base,
                          backgroundColor:
                            theme === "dark" ? "#242424" : "#fff",
                          borderRadius: "8px",
                          boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.2)",
                        }),
                        option: (base, { isFocused, isSelected }) => ({
                          ...base,
                          backgroundColor: isSelected
                            ? theme === "dark"
                              ? "#242424"
                              : "#ccc"
                            : isFocused
                            ? theme === "dark"
                              ? "#121212"
                              : "#ddd"
                            : "transparent",
                          color: theme === "dark" ? "#c3cbe4" : "#000",
                          padding: "10px",
                          fontSize: "0.9rem",
                          cursor: "pointer",
                        }),
                        singleValue: (base) => ({
                          ...base,
                          color: theme === "dark" ? "#c3cbe4" : "#000",
                        }),
                      }}
                    />
                  </Col>
                </Row>

                <Row>
                  <Col lg={6} className="mb-4">
                    <Label
                      style={{ color: theme === "dark" && "#c3cbe4" }}
                      for="calificacion"
                      className="form-label"
                    >
                      <i className="fas fa-star me-2"></i>Resultados
                    </Label>
                    <Select
                      id="calificacion"
                      name="calificacion"
                      placeholder="Seleccione"
                      onChange={(item) => {
                        setFormData({
                          ...formData,
                          calificacion: item.value,
                        });
                        setValidationErrors2({ calificacion: false });
                      }}
                      options={
                        Array.isArray(calificacionList)
                          ? calificacionList.map((item) => ({
                              label: item.name,
                              value: item.id,
                            }))
                          : []
                      }
                      styles={{
                        control: (base) => ({
                          ...base,
                          backgroundColor:
                            theme === "dark" ? "#3b3b3b" : "#fff",
                          color: theme === "dark" ? "#c3cbe4" : "#000",
                          borderColor: theme === "dark" ? "#4f4f4f" : "#d2d2d2",
                          cursor: "pointer",
                          fontSize: "0.9rem",
                        }),
                        menu: (base) => ({
                          ...base,
                          backgroundColor:
                            theme === "dark" ? "#242424" : "#fff",
                          borderRadius: "8px",
                          boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.2)",
                        }),
                        option: (base, { isFocused, isSelected }) => ({
                          ...base,
                          backgroundColor: isSelected
                            ? theme === "dark"
                              ? "#242424"
                              : "#ccc"
                            : isFocused
                            ? theme === "dark"
                              ? "#121212"
                              : "#ddd"
                            : "transparent",
                          color: theme === "dark" ? "#c3cbe4" : "#000",
                          padding: "10px",
                          fontSize: "0.9rem",
                          cursor: "pointer",
                        }),
                        singleValue: (base) => ({
                          ...base,
                          color: theme === "dark" ? "#c3cbe4" : "#000",
                        }),
                      }}
                      isInvalid={validationErrors2.calificacion}
                    />
                    {validationErrors2.calificacion && (
                      <div className="text-danger small">
                        La calificación es obligatoria
                      </div>
                    )}
                  </Col>
                  <Col lg={6} className="mb-4">
                    <Label
                      style={{ color: theme === "dark" && "#c3cbe4" }}
                      for="descripcion"
                      className="form-label"
                    >
                      <i className="fas fa-info-circle me-2"></i>Calificación
                    </Label>
                    <Select
                      id="descripcion"
                      name="descripcion"
                      placeholder="Seleccione"
                      options={
                        Array.isArray(descripcionList)
                          ? descripcionList.map((item) => ({
                              label: item.name,
                              value: item.id,
                            }))
                          : []
                      }
                      onChange={(item) => {
                        setFormData({
                          ...formData,
                          descripcion: item.value,
                        });
                        setValidationErrors2({ descripcion: false });
                      }}
                      styles={{
                        control: (base) => ({
                          ...base,
                          backgroundColor:
                            theme === "dark" ? "#3b3b3b" : "#fff",
                          color: theme === "dark" ? "#c3cbe4" : "#000",
                          borderColor: theme === "dark" ? "#4f4f4f" : "#d2d2d2",
                          cursor: "pointer",
                          fontSize: "0.9rem",
                        }),
                        menu: (base) => ({
                          ...base,
                          backgroundColor:
                            theme === "dark" ? "#242424" : "#fff",
                          borderRadius: "8px",
                          boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.2)",
                        }),
                        option: (base, { isFocused, isSelected }) => ({
                          ...base,
                          backgroundColor: isSelected
                            ? theme === "dark"
                              ? "#242424"
                              : "#ccc"
                            : isFocused
                            ? theme === "dark"
                              ? "#121212"
                              : "#ddd"
                            : "transparent",
                          color: theme === "dark" ? "#c3cbe4" : "#000",
                          padding: "10px",
                          fontSize: "0.9rem",
                          cursor: "pointer",
                        }),
                        singleValue: (base) => ({
                          ...base,
                          color: theme === "dark" ? "#c3cbe4" : "#000",
                        }),
                      }}
                      isInvalid={validationErrors2.descripcion}
                    />
                    {validationErrors2.descripcion && (
                      <div className="text-danger small">
                        La descripción es obligatoria
                      </div>
                    )}
                  </Col>
                </Row>

                <Row>
                  <Col lg={6} className="mb-4">
                    <Label
                      style={{ color: theme === "dark" && "#c3cbe4" }}
                      for="ciudad"
                      className="form-label"
                    >
                      <i className="fas fa-city me-2"></i>Ciudad
                    </Label>
                    <Select
                      placeholder="Seleccione"
                      options={ciudadOptions}
                      onChange={(item) =>
                        setFormData({
                          ...formData,
                          sala_ventas: item.value,
                        })
                      }
                      styles={{
                        control: (base) => ({
                          ...base,
                          backgroundColor:
                            theme === "dark" ? "#3b3b3b" : "#fff",
                          color: theme === "dark" ? "#c3cbe4" : "#000",
                          borderColor: theme === "dark" ? "#4f4f4f" : "#d2d2d2",
                          cursor: "pointer",
                          fontSize: "0.9rem",
                        }),
                        menu: (base) => ({
                          ...base,
                          backgroundColor:
                            theme === "dark" ? "#242424" : "#fff",
                          borderRadius: "8px",
                          boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.2)",
                        }),
                        option: (base, { isFocused, isSelected }) => ({
                          ...base,
                          backgroundColor: isSelected
                            ? theme === "dark"
                              ? "#242424"
                              : "#ccc"
                            : isFocused
                            ? theme === "dark"
                              ? "#121212"
                              : "#ddd"
                            : "transparent",
                          color: theme === "dark" ? "#c3cbe4" : "#000",
                          padding: "10px",
                          fontSize: "0.9rem",
                          cursor: "pointer",
                        }),
                        singleValue: (base) => ({
                          ...base,
                          color: theme === "dark" ? "#c3cbe4" : "#000",
                        }),
                      }}
                    />
                  </Col>
                  <Col lg={6} className="mb-4">
                    <Label
                      style={{ color: theme === "dark" && "#c3cbe4" }}
                      for="placa"
                      className="form-label"
                    >
                      <i className="fas fa-car me-2"></i>Placa
                    </Label>
                    <input
                      className="input_create_contact input_background"
                      id="placa"
                      name="placa"
                      type="text"
                      onChange={(e) =>
                        setFormData({ ...formData, placa: e.target.value })
                      }
                      onInput={(e) =>
                        (e.target.value = e.target.value.toUpperCase())
                      }
                    />
                  </Col>
                </Row>

                <Row>
                  <Col lg={12} className="mb-4">
                    <Label
                      style={{ color: theme === "dark" && "#c3cbe4" }}
                      for="observaciones"
                      className="form-label"
                    >
                      <i className="fas fa-edit me-2"></i>Observaciones
                    </Label>
                    <textarea
                      id="observaciones"
                      className="textArea_create_contact input_background"
                      name="observaciones"
                      rows={3}
                      onChange={(e) =>
                        setFormData({
                          ...formData,
                          observaciones: e.target.value,
                        })
                      }
                    />
                  </Col>
                </Row>

                <Row>
                  <Col lg={12} className="mb-4">
                    <div className="next-contact-header">
                      <i className="fas fa-calendar-alt me-2"></i>
                      <b>Próximo Contacto (Opcional)</b>
                    </div>
                  </Col>
                </Row>

                <Row>
                  <Col lg={6} className="mb-4">
                    <Label
                      style={{ color: theme === "dark" && "#c3cbe4" }}
                      for="date"
                      className="form-label"
                    >
                      Fecha
                    </Label>
                    <input
                      className="input_create_contact input_background"
                      id="date"
                      name="date"
                      type="date"
                      onChange={(e) => {
                        setFormData({
                          ...formData,
                          fecha_proximo_contacto: e.target.value,
                        });
                      }}
                    />
                  </Col>
                  <Col lg={6} className="mb-4">
                    <Label
                      style={{ color: theme === "dark" && "#c3cbe4" }}
                      for="time"
                      className="form-label"
                    >
                      Hora
                    </Label>
                    <input
                      className="input_create_contact input_background"
                      id="time"
                      name="time"
                      type="time"
                      onChange={(e) => {
                        setFormData({
                          ...formData,
                          hora_proximo_contacto: e.target.value,
                        });
                      }}
                    />
                  </Col>
                </Row>

                <Row style={{ marginRight: "-1rem" }} className="mt-2">
                  <Col className="d-flex justify-content-end">
                    <button
                      type="button"
                      className="button_cancel me-2 "
                      onClick={onClose}
                    >
                      Cerrar
                    </button>
                    <button
                      type="button"
                      className="button_create"
                      onClick={onSubmit}
                    >
                      Guardar Gestión
                    </button>
                  </Col>
                </Row>
              </div>
            )}
          </div>
        </ModalBody>
      </Modal>
    </>
  );
};

export default ManagementManual;